export default __webpack_public_path__ + "static/media/Group 5181.0742bde9.svg";